<template>
  <div id="upgradedusers_wrap">
    <headers />
    <div id="login_wrap_denglu">
      <div class="login_wrap_denglu_top">请填写学校信息</div>
      <div class="yanzhengma_enter">欢迎学校入驻</div>
    </div>
    <el-form class="center_wrap" :model="formData" :rules="rules" ref="ruleForm">
      <div class="approve_msg">
        <div class="upgradeuser">
          <div class="upgradeuser_form_wrap">
            
            <div class="pinpai_content">
              <i class="erro-text">*</i>学校名称</div>
            <el-form-item class="jigou_mingcheng_text" prop="schoolName">
              <el-input v-model="formData.schoolName" placeholder="请输入学校名称" class="jigou_mingcheng_text_in" ></el-input>
            </el-form-item>
          
            <div class="pinpai_leimu">
              <i class="erro-text">*</i>主营类目</div>
            <el-form-item class="pinpai_leimu_content" prop="mainCategories">
              <el-select v-model="formData.mainCategories" placeholder="请选择"  style="width:260px">
                <el-option v-for="item in mainCategoriesArr" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <div class="pinpai_content_adress">
              <i class="erro-text">*</i>所在地址</div>
            <el-form-item class="pinpai_content_adress_content" prop="country">
              <el-select filterable style="width:260px" v-model="formData.country" placeholder="请选择国家" class="country_select" @change="country_change" >
                <el-option v-for="item in  countryArr" :key="item.value" :label="item.name" :value="item.name">
                </el-option>
              </el-select>
              <el-select filterable style="width:260px" v-model="formData.province" placeholder="请选择省/直辖市" class="country_select" v-show="see_province" @change="city_end" >
                <el-option v-for="item in  provinceArr" :key="item.value" :label="item.name" :value="item.name">
                </el-option>
              </el-select>
              <el-select filterable style="width:260px" v-model="formData.city" placeholder="请选择城市" class="country_select" v-show="see_province_surplus" >
                <el-option v-for="item in  cityArr" :key="item.value" :label="item.name" :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>

            <div class="pinpai_content">
              <i class="erro-text">*</i>学校管理员姓名</div>
            <el-form-item class="jigou_mingcheng_text" prop="chargePerson">
              <el-input v-model="formData.chargePerson" placeholder="请输入学校管理员姓名" class="jigou_mingcheng_text_in" ></el-input>
            </el-form-item>

            <div class="pinpai_content">
              <i class="erro-text">*</i>学校管理员手机号</div>

            <div v-show="!changePhoneFlag">
              <div class="jigou_mingcheng_text">
                <span style="font-size:14px">{{showPhone}}</span>   
                <div style="float:right;color: #3366ff;cursor:pointer;font-size:14px" @click="changePhone">更换</div>
              </div>
            </div>

            <!-- 更换手机号 -->
            <div style="height:160px;" v-show="changePhoneFlag">
              <el-form-item style="width:80px;float:left;" prop="area">
                <el-select v-model="formData.area" placeholder="区号" filterable>
                  <el-option v-for="item in cities" :key="item.label" :label="item.value" :value="item.value" >
                    <span style="float: left">{{ item.label }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="login_wrap_form_number_right" style="width:175px;float:left;margin-left:5px" prop="phone">
                <el-input type="number" v-model="formData.phone" placeholder="请输入手机号码" class="login_wrap_form_number_right_int" ></el-input>
              </el-form-item>
               <el-form-item style="width:120px;float:left;margin-top:10px;margin-right:5px" prop="validatorCode">
                <el-input placeholder="请输入验证码" type="number"  v-model="formData.validatorCode"  ></el-input>
              </el-form-item>
              <el-form-item style="float:left;margin-top:10px;" >
                <el-button  style="height: 30px;line-height: 30px;padding: 0;width: 80px;" @click="sendvalidatorCode"
                :disabled="isDisabled" >{{buttonName}}</el-button>
              </el-form-item>
               <el-form-item style="float:left;margin-top:10px;" >
                <el-button  style="height: 30px;line-height: 30px;padding: 0;width: 50px;margin-left:5px" @click="changePhone">取消</el-button>
              </el-form-item>
              <el-form-item style="float:left;margin-top:-20px" >
                <div style="font-size:12px;color:#999;">手机号验证后，该号码将成为学校管理员，请谨慎填写。</div>
              </el-form-item>
            </div>
            <div class="login_susses">
              <el-button type="success" @click="go_enter">下一步</el-button>
              <el-button type="danger" @click="blank_to">返回</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-form>
    <footers />
  </div>
</template>

<script>
import headers from "./header.vue";
import footers from "./footers.vue";
import Net_Work from "../apis/network.js";
import Address from "../apis/address.js";
import axios from "axios";
import Qs from "qs";
import { try_get_token } from "../apis/token.js";

axios.defaults.baseURL = Net_Work.publicApi;
axios.defaults.headers.post["Content-Type"] = Net_Work.publicPostset;

export default {
  name: "new_upgradedusers",
  data() {
    return {

      // 是否改变手机号状态位
      changePhoneFlag: false,
      // 显示手机号
      showPhone: '',

      // 验证码倒计时s
      timerCount: 60,
      buttonName: '获取验证码',
      isDisabled: false,

      // 表单数据
      formData: {
          // 学校ID
          schoolId: 0,
          // 学校名称
          schoolName: '',
          // 手机区号
          area: '',
          // 手机号
          phone: '',
          // 验证码
          validatorCode: '',
          // 验证码key
          validatorKey: '',
          // 管理员手机号
          chargePersonPhone:'',
          // 国家
          country: '',
          // 省
          province:'',
          // 区
          city:'',
          // 类目
          mainCategories:'',
          // 管理员姓名
          chargePerson: ''
      },

      // 校验规则
      rules: {
          schoolName: [
            { required: true, message: '请输入学校名称', trigger: 'blur' },
            { max: 30, message: '最长30个字符', trigger: 'blur' }
          ],
          mainCategories:[
            { required: true, message: '请选择主营类目', trigger: 'blur' },
          ],
          country:[
            { required: true, message: '请选择所在地址', trigger: 'blur' },
          ],
          chargePerson:[
            { required: true, message: '请填写学校管理员姓名', trigger: 'blur' },
          ],
          phone:[
            {
              validator:  (rule, value, callback) => {
                  if(this.changePhoneFlag) {
                      if(!value){
                        callback(new Error('请输入手机号'));
                        return;
                      }
                  } 
                  callback();
              }, trigger: 'blur'
            }
          ],

          validatorCode:[
            {
               validator:  (rule, value, callback) => {
                  if(this.changePhoneFlag) {
                      if(!value){
                        callback(new Error('请输入验证码'));
                        return;
                      }
                  } 
                  callback();
              }, trigger: 'blur'
            }
          ],

          area: [
            {
               validator:  (rule, value, callback) => {
                  if(this.changePhoneFlag) {
                      if(!value){
                        callback(new Error('请选择区号'));
                        return;
                      }
                  } 
                  callback();
              }, trigger: 'blur'
            }
          ],

      },

      // 国家区号列表
      cities: Address.citiy,
      
      // 位置列表
      countryArr: Address.arrcity,
      provinceArr: [],
      cityArr: [], 
      see_province: false,
      see_province_surplus: false,

      // 类目列表
      mainCategoriesArr: Address.pinpai_leimu_datas,

      changePhoneFlag: false
    };
  },
  methods: {

    // 切换手机号
    changePhone(){
      this.changePhoneFlag = !this.changePhoneFlag;
    },

    blank_to() {
        this.$router.push("/school-join");
    },

    // 国家改变
    country_change() {

      // 清空省市数据
      this.formData.province = "";
      this.formData.city = "";
      // 城市和省份不显示
      this.see_province = false;
      this.see_province_surplus = false;

      var _this = this;

      // 获取省份
      var province_data = this.countryArr.find((item) => {
        return item.name === _this.formData.country;
      });

      // 如果存在
      if (province_data && province_data.state) {
        
        // 如果是数组，则获取二级数据
        if (province_data.state instanceof Array) {
          this.see_province = true;
          this.provinceArr = province_data.state;
        } 
        // 如果是对象，则获取三级数据
        else if (province_data.state instanceof Object) {
          this.see_province = true;
          this.provinceArr = province_data.state.city;;
        }

      } 

    },

    // 省份改变
    city_end() {
      
      // 清空城市数据
      this.formData.city = "";

      var _this = this;

      // 获取城市
      var city_data = this.provinceArr.find((item) => {
        return item.name === _this.formData.province;
      });

      if (city_data.city) {
        this.see_province_surplus = true;
        this.cityArr = city_data.city;
      } else {
        this.see_province_surplus = false;
      }
      
    },
    
    // 数据提交
    go_enter(){
      
      this.$refs["ruleForm"].validate((valid) => {
          if (valid) {


            // 是否改变手机号标志位
            this.formData.changePhoneFlag = this.changePhoneFlag;

            axios.post( "/s/api/school/base/info", Qs.stringify(this.formData)).then(response => {
              if (response.data.code == 0) {
                var _this = this;
                this.$message({
                  showClose: true,
                  message: response.data.msg,
                  duration: 1000,
                  type: "success",
                  onClose() {
                    _this.$router.push({
                        path: "/solution-apply",
                        query: {
                            version: _this.$route.query.version
                        }
                    });
                  }
                });
              } else {
                this.$message({
                  showClose: true,
                  message: response.data.msg,
                  type: "error"
                });
              }
            }).catch(function(error) {});

          } else {
            console.log('error submit!!');
            return false;
          }
      });

    },

    // 发送验证码
    sendvalidatorCode(){
      
      if(!this.formData.area){
         this.$message({
            showClose: true,
            message: '请选择区号',
            type: "error"
          });
        return;
      }

      if(!this.formData.phone){
         this.$message({
            showClose: true,
            message: '请填写手机号',
            type: "error"
         });
        return;
      }

      // 区号
      var number_quhao = Number(this.formData.area);
      var _this = this;

      axios.post("/n/api/sms/send", Qs.stringify({
        areaCode: number_quhao,
        phone: this.formData.phone
      }))
      .then(function(response) {
        if (response.data.code == 0) {

            // 设置验证码的key
            _this.formData.validatorKey = response.data.data.key;

            // 定时刷新倒计时
            let clock = setInterval(() => {
              _this.timerCount--;
              _this.buttonName =  _this.timerCount + '秒';
              if (_this.timerCount < 0) {
                _this.timerCount = 60;
                _this.isDisabled = false;
                _this.buttonName = '获取验证码';
                window.clearInterval(clock);
              }
            }, 1000);
            
            // 验证码按钮禁用
            _this.isDisabled = true;

        }  else {
            _this.$message.error({
                showClose: true,
                message: response.data.msg
            });
        } 
      })
      .catch(function(error) {
        console.log(error);
      });

    },

    // 获取显示手机号
    getShowPhone(phone){
      
      var length = phone.length;
      if(length <= 4){
        return "****";
      }

      var index = (length - 4) /2;
      return phone.replace(phone.substring(index ,index + 4), "****")
    }

       
  },
  components: {
    headers,
    footers
  },
  created() {

    var _this = this;
    var access_token = try_get_token();

    if (!access_token) {
      this.$router.push("/school-join");
      return ;
    } 

    axios.defaults.headers.common["Authorization"] = access_token;

    // 获取申请的学校信息
    axios.get("/s/api/school/getApplySchool").then(function(response) {
        if (response.data.code === 0) {
          if (response.data.data) {

            // 属性赋值
            for(var key in _this.formData){
              _this.formData[key] = response.data.data[key];
            }

            // 临时存储省市
            var province = _this.formData.province;
            var city = _this.formData.city;

            if(province){
              _this.country_change();
              _this.formData.province = province;
            }

            if(city){
              _this.city_end();
              _this.formData.city = city;
            }

            // 默认显示当前登录用户的手机号
            _this.showPhone = _this.formData.chargePersonPhone;

            // 手机号分割
            if(_this.formData.chargePersonPhone){
             var index = _this.formData.chargePersonPhone.indexOf(" ");
             if(index > -1){
                _this.formData.area = "+" + _this.formData.chargePersonPhone.substring(0,index);
                _this.showPhone = _this.formData.chargePersonPhone.substring(0,index) 
                  + _this.getShowPhone(_this.formData.chargePersonPhone.substring(index));
                _this.formData.chargePersonPhone = "";
             }
            }

          } else {
             // 获取登录用户信息
            axios.get("/s/api/getLoginUser").then(function(res) {
               if (res.data.code === 0) {
                   _this.showPhone = res.data.data.areaCode + " " + _this.getShowPhone(res.data.data.phone);
               }
            });
          }
        } else if (response.data.code === 401) {
          _this.$message({
            showClose: true,
            message: response.data.msg,
            duration: 1000,
            showClose: false,
            type: "error",
            onClose: () => {
              window.scrollTo(0, 0);
              _this.$router.push("/school-join");
            }
          });
        } else {
           
        }
      })
      .catch(function(error) {
        // handle error
      });
  }
};
</script>
<style lang="less" scoped>
.erro-text {
  color: #f56c6c;
  font-size: 12px;
  margin-right: 4px;
  padding-top: 3px;
}
#upgradedusers_wrap {
  #login_wrap_denglu {
    width: 100%;
    height: 155px;
    overflow: hidden;
    background-color: #eee;
    text-align: center;
    .is-user {
      color: #409eff !important;
    }
    .login_wrap_denglu_top {
      font-family: " MicrosoftYaHei";
      font-size: 30px;
      color: #222743;
      margin-top: 45px;
    line-height: 52px;
    letter-spacing: 1px;
    }
    .yanzhengma_enter {
      color: #066fff;
      font-family: " MicrosoftYaHei";
      margin-top: 10px;
      display: inline-block;
    }
    .user_one {
      > span {
        font-size: 20px;
        line-height: 24px;
        margin-top: 8px;
        display: inline-block;
        color: #ccc;
      }
    }
    .is-user {
      > span {
        color: #409eff;
      }
    }
  }

  .center_wrap {
    display: flex;
    justify-content: center;
  }

  .approve_msg {
    display: block;
    width: fit-content;

    .approve_state_one_left {
      font-size: 12px;
      font-weight: 900;
      margin-right: 24px;
    }

    .approve_state_one_right {
      font-size: 12px;
    }
  }

  .approve_state_two {
    .approve_state_one_right {
      color: #f56c6c;
    }
  }
}

.upgradeuser {
  width: 100%;
  padding-bottom: 80px;

  .upgradeuser_form_wrap {
    width: 320px;
    height: auto;
    margin-top: 16px;

    // border: 1px solid red;
    .pinpai_content {
      font-family: "MicrosoftYaHei";
      font-size: 12px;
      color: #999999;
      margin-top: 20px;
      line-height: 20px;
      display: flex;
      align-items: center;
    }

    .jigou_mingcheng_text {
      width: 260px;
      margin-top: 10px;
    }
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 260px;
    height: 90px;
    line-height: 90px;
    text-align: center;
    border: 1px dashed #c7c7cc;
  }

  .avatar {
    width: 260px;
    height: 90px;
    display: block;
  }

  .logo_text_content {
    font-family: "MicrosoftYaHei";
    font-size: 12px;
    // color: #999999;
    margin-top: 5px;
    color: #f56c6c;
  }

  .pinpai_leimu {
    font-family: "MicrosoftYaHei";
    font-size: 12px;
    color: #999999;
    margin-top: 20px;
  }

  .pinpai_content_adress {
    font-family: "MicrosoftYaHei";
    font-size: 12px;
    color: #999999;
    margin-top: 20px;
  }

  .pinpai_leimu_content {
    width: 260px;
    margin-top: 10px;
  }

  .country_select {
    width: auto;
    margin-bottom: 8px;
  }

  .pinpai_content_adress_content {
    margin-top: 20px;
  }

  .business_license {
    display: flex;
    margin-top: 10px;

    .agree_tiaoyue_text {
      line-height: 32px;
      font-size: 12px;
      margin-left: 10px;
    }
  }

  .license_one {
    .pinpai_content {
      margin-top: 10px;
    }
  }

  .newpinpai_content {
    margin-top: 20px !important;
  }

  .license_two {
    .pinpai_content {
      margin-top: 10px !important;
    }
  }

  .login_susses {
    display: flex;
  }

  .login_susses {
    margin-top: 20px;

    .el-button {
      width: 60px;
      font-size: 12px;
      border-radius: 0px;
      height: 24px;
      line-height: 24px;
      padding: 0;
    }
  }

  .number_erro {
    display: flex;
    margin-top: 3px;

    .number_erro_content {
      width: 170px;
      font-size: 12px;
      color: #f56c6c;
      font-family: "MicrosoftYaHei";

      /**/
    }
  }

  .colordisplay {
    visibility: hidden;
  }

  .colordisplay_address {
    visibility: hidden;
  }

  .colordisplay_web {
    visibility: hidden;
  }

  .colorerro_nine {
    visibility: hidden;
  }

  .colorerro_code {
    visibility: hidden;
  }

  .colorerro_ele {
    visibility: hidden;
  }

  .colorerro_email_erro {
    visibility: hidden;
  }

  .colorerro_people_law {
    visibility: hidden;
  }

  .colorerro_code_name {
    visibility: hidden;
  }

  .colorerro_code_name_code {
    visibility: hidden;
  }

  .span_erro {
    color: #f56c6c;
    margin-left: 10px;
  }
}
</style>
<style lang="less">
.upgradeuser_form_wrap {
  .el-input__inner {
    padding: 0;
    margin: 0;
    padding-left: 11px;
    border-radius: 3px;
    height: 30px;
  }

  .el-input__suffix {
    right: -2px;
  }

  .el-input__icon {
    line-height: 30px;
  }

  .color_qiye_one {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }

  .colorerro_seven {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }

  .colorerro_three {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }

  .colorerro_four {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }

  .colorerro_six {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }

  .colorerro_q {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }

  .color_qiye_web {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }

  .colorerro_eight {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }

  .colorerro_ten {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }

  .colorerro_email {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }

  .colorerro_low {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }

  .colorerro_low_code {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }

  .colorerro_shenfen_code {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }

  .colorerro_shenfen_name {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }

  .colorerro_shenfen_name_code {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }

  .color_qiye_ones {
    .el-input__inner {
      border-color: #f56c6c;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/new_upgrade.vue